import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "StarOff"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M512 748l228 120q4 0.992 7.008-0.992t2.016-6.016l-43.008-254.016 184-180q3.008-3.008 2.016-6.496t-4.992-4.512l-255.008-36.992-114.016-231.008q-2.016-4-6.016-4t-6.016 4l-114.016 231.008-255.008 36.992q-4 0.992-4.992 4.512t2.016 6.496l184 180-44 254.016q0 4 3.008 6.016t7.008 0.992z m-197.984 176q-19.008 10.016-38.496 8.512t-36-13.504-24-30.496-4.512-38.496l38.016-220.992-160-156q-15.008-14.016-19.488-33.504t2.016-39.008 21.504-32 35.008-15.488l222.016-32 99.008-200.992q8.992-19.008 26.016-28.992t36.992-10.016 36.992 10.016 26.016 28.992l99.008 200.992 222.016 32q20 3.008 35.488 15.488t21.504 32 1.504 39.008-19.488 33.504l-160 156 38.016 220.992q3.008 20-4.512 38.496t-24 30.496-36 13.504-38.496-7.488l-198.016-104.992z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var starOff = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\star-off.vue"]]);

export { starOff as default };
